"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlertBehaviourViewItems = void 0;
const AdaptableContext_1 = require("../../../View/AdaptableContext");
const AlertBehaviourWizardSection_1 = require("../../../View/Alert/Wizard/AlertBehaviourWizardSection");
const BehaviourView = (props) => {
    const adaptable = (0, AdaptableContext_1.useAdaptable)();
    return (0, AlertBehaviourWizardSection_1.renderAlertBehaviourSummary)(props.data, adaptable.api, true);
};
const getAlertBehaviourViewItems = (api) => {
    return {
        name: api.internalApi.getCorrectEnglishVariant('Behaviour'),
        view: BehaviourView,
    };
};
exports.getAlertBehaviourViewItems = getAlertBehaviourViewItems;
